import Marionette from 'backbone.marionette';
import Navigator from 'app';
import CommitteeMeetingCollectionview from './committee_meeting_itemview';
import CommitteeMeetingEmptyview from './committee_meeting_emptyview';
export default Marionette.CollectionView.extend({
  childView: CommitteeMeetingCollectionview,
  tagName: "div",
  //className: "border",
  emptyView: CommitteeMeetingEmptyview,
  initialize: function () {
    this.period = "this_week"; // some abandoned code commented out below to allow period switching
    const self = this;
    Navigator.vent.on("event:day:change", function (index) {
      const date = Navigator.days.models[index].get("legislative_day_date");
      console.log("Show bill committee meetings for: ", date);
      const fetchingMeetings = Navigator.request("meetings:" + self.collection.chamber, self.period, date);
      $.when(fetchingMeetings).done(function (meetings) {
        self.collection.reset(meetings.models);
        self.render();
      });
    });

    // never implemented
    /* Navigator.vent.on("meetings:today", function() {
         self.getMeetingsFor("today");
    });
    Navigator.vent.on("meetings:thisweek", function() {
      self.getMeetingsFor("this_week");
    });
     Navigator.vent.on("meetings:nextweek", function() {
      self.getMeetingsFor("next_week");
    });*/
  }
  /* getMeetingsFor: function(period) {
    this.period = period;
    const self = this;
    const fetchingMeetings = Navigator.request("meetings:" + self.collection.chamber, self.period);
    $.when(fetchingMeetings).done(function(meetings) {
      self.collection.reset(meetings.models);
    });
  }*/
});